import styled from '@emotion/styled';
import React from 'react';

type Props = {
  onClick?: () => void;
  children: React.ReactNode;
};

export const ClickableLabel: React.FC<Props> = ({ onClick, children }) => {
  if (!onClick) {
    return <>{children}</>;
  }

  return (
    <StyledClickable
      role="button"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
          e.preventDefault();
          onClick();
        }
      }}>
      {children}
    </StyledClickable>
  );
};

const StyledClickable = styled('span')({
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
});
